import { Box, Typography } from "@dealer-center/core-components";

export const InventoryLanding = () => (
  <Box data-testid="inventory-landing" sx={{ padding: "16px" }}>
    <Typography variant="h1">Inventory</Typography>
    <Typography variant="body-md">Inventory pages are coming soon.</Typography>
  </Box>
);
